import React from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDialogsContext } from '../../contexts/Dialog';

const useStyles = makeStyles((theme: any) => ({
  button: {
    fontSize: ({ fontSize }: any) => `${fontSize}em`,
  },
}));

export default function ConnectButton({
  text = 'Connect Amazon',
  contained,
  primary,
  fontSize,
  disabled = false,
}) {
  const classes = useStyles({ fontSize });
  const dialogs = useDialogsContext();
  return (
    <Button
      color={primary ? 'primary' : 'default'}
      className={classes.button}
      variant={contained ? 'contained' : 'text'}
      onClick={() => dialogs.open('connectAmazonSeller')}
      disabled={disabled}
    >
      {text}
    </Button>
  );
}
